export enum DeviceType {
  IOS = 'ios',
  ANDROID = 'Android',
  GENERAL = 'general',
}
